module.exports = __webpack_public_path__ + "img/Tongdalogo.c8dc1bc5.svg";